import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=b7019710&"
import script from "./AddressSelect.vue?vue&type=script&lang=js&"
export * from "./AddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports